import { render } from "./Rates.vue?vue&type=template&id=00504b69&scoped=true&ts=true"
import script from "./Rates.vue?vue&type=script&lang=ts"
export * from "./Rates.vue?vue&type=script&lang=ts"

import "./Rates.vue?vue&type=style&index=0&id=00504b69&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00504b69"]])

export default __exports__